import styled from 'styled-components';

export const StyledTableContainer = styled.div`
  min-width: 800px;
  .table_head_q {
    display: none;
  }
`;
